module.exports = __webpack_public_path__ + "static/img/employee_02.8f17aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2022/corona/employee_02.png
// module id = QEys
// module chunks = 0